import { createApp, h } from 'vue'
import { createPinia } from 'pinia'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VCalendar from 'v-calendar'
import Toast from 'vue-toastification'
import { toastOptions } from './config/toastConfig'
import App from './App.vue'
import { router } from './router'
import '@/assets/css/tailwind.css'
import 'v-calendar/dist/style.css'
import '@/assets/css/calendar.css'
import 'vue-toastification/dist/index.css'
import '@/assets/css/toast.css'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import VueGoodTablePlugin from 'vue-good-table-next'
import 'vue-good-table-next/dist/vue-good-table-next.css'
import AuthorizationPlugin from '@/plugins/authorization'
import { vProtectedImage } from '@/directives/vProtectedImage'
import { vMask } from '@/directives/vMask'
import { piniaResetPlugin } from '@/plugins/piniaResetPlugin'
import { handleGlobalError, installUnhandledRejectionListener } from '@/utils/globalErrorHandler'
import { applyStationPaletteCssVars, isStationPaletteV3Enabled } from '@/theme/stationPalette'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
const customTheme = {
  dark: false,
  colors: {
    primary5: '#D8EEF3',
    primary20: '#3CA2B9',
    primary30: '#2F7F91',
    secondary50: '#16161D',
    secondary: '#16161D',
    neutral50: '#323232',
    alert: '#F18F1B',
    warning: '#F1C21B',
    info: '#F1C21B',
    success: '#198038',
    negative: '#DA1E28',
    error: '#DA1E28',
    primary: '#2F7F91',
    textPrimary: '#16161D',
    primary10: '#84C8D7',
    tertiary: '#E37796',
    light: '#3CA2B9',
    neutralLight: '#BCBCCD',
    feedBackSuccess: '#198038',
    feedBackAlert: '#F18F1B',
    lightGray30: '#D8D8E2',
    background: '#FFFFFF',
    iconGrey: '#68688D'
  }
}

import DashboardLayoutVue from './components/layouts/DashboardLayout.vue'
import EmptyLayoutVue from './components/layouts/EmptyLayout.vue'
import AffiliateLayoutVue from './components/layouts/AffiliateLayout.vue'
import { VDataTable } from 'vuetify/labs/VDataTable'
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader'

export default function () {
  const rootComponent = {
    render: () => h(App),
    components: { App }
  }

  const pinia = createPinia()
  pinia.use(piniaResetPlugin)

  const vuetify = createVuetify({
    theme: {
      defaultTheme: 'customTheme',
      themes: {
        customTheme
      }
    },
    icons: {
      defaultSet: 'mdi',
      aliases,
      sets: {
        mdi
      }
    },
    components: {
      VDataTable,
      VSkeletonLoader
    }
  })

  const app = createApp(rootComponent)

  // remove this to disable the template layout dashboard
  app.component('default-layout', DashboardLayoutVue)
  app.component('empty-layout', EmptyLayoutVue)
  app.component('affiliate-layout', AffiliateLayoutVue)
  app.component('v-select', vSelect)

  app.use(VCalendar, {})
  app.use(pinia)
  app.use(vuetify)
  app.use(router)
  app.use(AuthorizationPlugin)
  app.use(Toast, toastOptions)
  app.use(VueGoodTablePlugin)

  // Rede de segurança: erros não tratados de componentes e promises rejeitadas
  // sem catch logam no console e toastam (com dedupe). Ver globalErrorHandler.
  app.config.errorHandler = (err) => handleGlobalError(err)
  installUnhandledRejectionListener()

  // Paleta v3 (SPEC-v3 §7.2): variáveis da vaga para os <style> escopados. Desligada, cada
  // var(--st-open-*, <legado>) cai no fallback, que é a cor de hoje.
  if (isStationPaletteV3Enabled()) applyStationPaletteCssVars(document.documentElement)

  app.directive('protected-image', vProtectedImage)
  app.directive('maska', vMask)

  return {
    app,
    router
  }
}
